export default "https://d1e6s5z4lzmgxx.cloudfront.net/9448f7a6-2ffc-48da-926d-72a27a448f00/images/ob-step-16.png?4c3023f2059d4abcfb65afe5a1d1ad52";